/****************
 * CopyFi's channels. FOLLOW goes to the channels themselves (Guillaume's /preview
 * review #4, 10-24): the copyfi.ai/telegram|tiktok|ig short links are INBOUND
 * (channel -> site, they set the cf_src cookie and land on the homepage), so the
 * icons used to open the CopyFi homepage. CONTACT is for help, an emergency
 * included: Telegram @copyfi_ai1 and info@copyfi.ai. WhatsApp +1 514 224-3773
 * (Guillaume, 10-24). Twin files: frontend + mobile-app lib/social.ts.
 ****************/
export const SOCIAL_LINKS = [
  { key: 'telegram', url: 'https://t.me/copyfi_ai' },
  { key: 'tiktok', url: 'https://www.tiktok.com/@copyfi.ai' },
  { key: 'instagram', url: 'https://www.instagram.com/copyfi.ai' },
] as const;

export const CONTACT_LINKS = [
  { key: 'whatsapp', url: 'https://wa.me/15142243773' },
  { key: 'contactTelegram', url: 'https://t.me/copyfi_ai1' },
  { key: 'email', url: 'mailto:info@copyfi.ai' },
] as const;
